/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * working: on, and the vendor accepted an assertion for this server from a provider that can vouch now. not_proven: on, with no such acceptance yet. needs_attention: on but blocked, or no provider can vouch for it right now.
 */
export const EMAServiceServerStatus = {
  Working: "working",
  NotProven: "not_proven",
  NeedsAttention: "needs_attention",
} as const;
/**
 * working: on, and the vendor accepted an assertion for this server from a provider that can vouch now. not_proven: on, with no such acceptance yet. needs_attention: on but blocked, or no provider can vouch for it right now.
 */
export type EMAServiceServerStatus = OpenEnum<typeof EMAServiceServerStatus>;

/**
 * One live MCP server whose identity chaining binding for the service has been turned on.
 */
export type EMAServiceServer = {
  /**
   * The MCP server id.
   */
  id: string;
  /**
   * When the vendor last accepted an assertion for this server from a provider that can vouch now. Omitted when never.
   */
  lastAcceptedAt?: Date | undefined;
  /**
   * The MCP server name. Empty when it has none.
   */
  name: string;
  /**
   * The owning project.
   */
  projectId: string;
  /**
   * The owning project's name.
   */
  projectName: string;
  /**
   * The owning project's slug.
   */
  projectSlug: string;
  /**
   * The remote session issuer the server's sign-in trusts, such as an Okta authorization server: only that issuer can vouch for people on the server. Omitted when the server uses Speakeasy's own sign-in, where only Speakeasy can vouch.
   */
  signInIssuerId?: string | undefined;
  /**
   * The display name of sign_in_issuer_id. Omitted with it, or when the issuer has no name.
   */
  signInIssuerName?: string | undefined;
  /**
   * The MCP server slug. Empty when it has none.
   */
  slug: string;
  /**
   * working: on, and the vendor accepted an assertion for this server from a provider that can vouch now. not_proven: on, with no such acceptance yet. needs_attention: on but blocked, or no provider can vouch for it right now.
   */
  status: EMAServiceServerStatus;
};

/** @internal */
export const EMAServiceServerStatus$inboundSchema: z.ZodMiniType<
  EMAServiceServerStatus,
  unknown
> = openEnums.inboundSchema(EMAServiceServerStatus);

/** @internal */
export const EMAServiceServer$inboundSchema: z.ZodMiniType<
  EMAServiceServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    last_accepted_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    name: z.string(),
    project_id: z.string(),
    project_name: z.string(),
    project_slug: z.string(),
    sign_in_issuer_id: z.optional(z.string()),
    sign_in_issuer_name: z.optional(z.string()),
    slug: z.string(),
    status: EMAServiceServerStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "last_accepted_at": "lastAcceptedAt",
      "project_id": "projectId",
      "project_name": "projectName",
      "project_slug": "projectSlug",
      "sign_in_issuer_id": "signInIssuerId",
      "sign_in_issuer_name": "signInIssuerName",
    });
  }),
);

export function emaServiceServerFromJSON(
  jsonString: string,
): SafeParseResult<EMAServiceServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EMAServiceServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EMAServiceServer' from JSON`,
  );
}
